export const HomeHero = ( el ) => {
	const ui = {
		el,
		homeHeroScrollBtn: el.querySelector( '.home-hero__scroll' ),
		homeHeroEnd: el.querySelector( '.home-hero__end' )
	};

	// Scroll to bottom of home hero section
	ui.homeHeroScrollBtn.addEventListener( 'click', () => {
		ui.homeHeroEnd.scrollIntoView( true );
	});
};

export default HomeHero;
